import { Alert, Button, Typography } from '@mui/material';
import { MaterialIcon } from '@common/ui/MaterialIcon';
import { Stack } from '@mui/system';
import { useAponoAuth } from '@common/ui/Authenticated';

export function SetUpMfaBanner() {
  const { onSetUpMfa } = useAponoAuth();

  return (
    <Alert
      sx={{ alignItems: 'center' }}
      variant="outlined"
      severity="warning"
      action={
        <Button
          variant="contained"
          startIcon={<MaterialIcon symbol="shield_lock" weight={700} />}
          onClick={onSetUpMfa}
          sx={{ marginRight: '12px' }}
        >
          Set Up MFA
        </Button>
      }
    >
      <Stack>
        <Typography variant="subtitle2">Set Up Multi-Factor Authentication (MFA)</Typography>
        <Typography variant="helperText">
          It only takes a moment and helps keep your organization secure. MFA may be required to request sensitive
          access.
        </Typography>
      </Stack>
    </Alert>
  );
}
